import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { formatPhone } from './utils';

import './contacts-list.scss';

class ContactsPerson extends PureComponent {
  render() {
    return (
      <div className="contacts-person">
        {(!!this.props.direction) &&
          <h5 dangerouslySetInnerHTML={{ __html: this.props.direction }} />
        }

        <div className="contacts-person-info">
          <h3 dangerouslySetInnerHTML={{ __html: this.props.name }} />
          <p dangerouslySetInnerHTML={{ __html: this.props.position }} />
        </div>

        <div className="contacts-person-details">
          <a
            className="contacts-person-phone"
            href={`tel:${formatPhone(this.props.phone)}`}
            dangerouslySetInnerHTML={{ __html: this.props.phone }}
          />

          <a
            className="contacts-person-email"
            href={`mailto:${this.props.email}`}
            dangerouslySetInnerHTML={{ __html: this.props.email }}
          />
        </div>
      </div>
    );
  }
}

ContactsPerson.propTypes = {
  direction: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  phone: PropTypes.string,
  email: PropTypes.string
};

class ContactsList extends PureComponent {
  render() {
    return (
      <ul className="contacts-list">
        {this.props.items.map((item, key) =>
          <li key={key}>
            <ContactsPerson {...item} />
          </li>
        )}
      </ul>
    );
  }
}

ContactsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};

export default ContactsList;



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsList.js